export default "__VITE_ASSET__DNHbJQQd__"